import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useAtom } from 'jotai'
import { Oval } from 'react-loader-spinner'

import {
	IResponse,
	expertsAtom,
	expertsStartupsAtom,
	expertFilterAtom,
	expertStartupFilterAtom,
	ExpertsDefaultView,
	ExpertsStartUpView,
} from '../functions/_exports'
import { useSearchParams } from 'react-router-dom'

const App = () => {
	const [isLoading, setIsLoading] = useState(true)
	const [searchParams, setSearchParams] = useSearchParams()

	const [, setExperts] = useAtom(expertsAtom)
	const [, setExpertsStartup] = useAtom(expertsStartupsAtom)
	const [expertFilter, setExpertFilter] = useAtom(expertFilterAtom)
	const [expertStartUpFilter, setExpertStartUpFilter] = useAtom(expertStartupFilterAtom)

	useEffect(() => {
		axios('/api/experts', {
			method: 'GET',
		})
			.then((res: IResponse) => {
				const { expertList, expertStartUpList, expertFilterModel, expertStartUpFilterModel } =
					res.data

				setExperts(expertList)
				setExpertsStartup(expertStartUpList)
				setExpertFilter(expertFilterModel)
				setExpertStartUpFilter(expertStartUpFilterModel)

				setIsLoading(false)
			})

			.catch((error) => {
				console.error(error.message)
				setIsLoading(false)
			})

		// return () => {
		//   second
		// }
	}, [])

	return (
		<div className="container">
			<div id="tabs">
				<ul className="nav nav-tabs">
					<li className={searchParams.get('view') !== 'start-up' ? 'active' : ''}>
						<a onClick={() => setSearchParams({ view: 'rodinne-podnikanie' })}>
							Rodinné podnikanie
						</a>
					</li>
					<li className={searchParams.get('view') == 'start-up' ? 'active' : ''}>
						<a onClick={() => setSearchParams({ view: 'start-up' })}>Start Up</a>
					</li>
				</ul>
			</div>

			{isLoading ? (
				<div style={{ paddingTop: '15px' }}>
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							color: '#337ab7',
							fontWeight: 'bold',
						}}
					>
						<h3>Načítavanie</h3>
					</div>
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<Oval
							color="#144F9F"
							height={120}
							width={120}
							secondaryColor="#337AB7"
							strokeWidth={2}
						/>
					</div>
				</div>
			) : (
				<>
					{searchParams.get('view') !== 'start-up' && (
						<ExpertsDefaultView filter={expertFilter} />
					)}
					{searchParams.get('view') == 'start-up' && (
						<ExpertsStartUpView filter={expertStartUpFilter} />
					)}
				</>
			)}
		</div>
	)
}

export default App
